import { Container } from '@mui/system';
import React from 'react';
import { MotionViewport } from 'src/components/animate';
import TraCuuLoSamHomeView from 'src/sections/losam/view/tracuu-losam-home-view';

export default function HomeViewTraCuu() {
  return (
    <Container
      component={MotionViewport}
    > 
      <TraCuuLoSamHomeView />
    </Container>
  );
}
